export interface SelectableTemplate {
  id: string
  name: string
  version: number
}

/**
 * The templates a plan can actually be built from.
 *
 * A plan is composed from the latest *published* version, which is not the same
 * as the row's own id: once a Coordinator starts editing, the row describes the
 * new draft while the published version underneath is still perfectly usable.
 * Selecting by row id would make a template vanish from this list the moment
 * anyone opened it for editing.
 *
 * Shared by composing a plan and by attaching a checklist to one that exists,
 * so the two offer the same templates. The server enforces the same rule; this
 * is what stops a user being offered something it will refuse.
 */
export function selectable<
  T extends {
    latestPublishedVersionId: string | null
    latestPublishedVersion: number | null
    isRetired: boolean
    name: string
  },
>(items: T[] | undefined): (T & SelectableTemplate)[] {
  return (items ?? [])
    .filter((item) => !item.isRetired && item.latestPublishedVersionId !== null)
    .map((item) => ({
      ...item,
      id: item.latestPublishedVersionId!,
      version: item.latestPublishedVersion!,
    }))
}
